import { styled } from '$utils/theme'
import { Block } from '$views/components'
import { rem } from 'polished'
import { Icon } from '$views/components/Icon'

export const ServiceColumn = styled(Block)`
  grid-column: 2;
  ${p => p.theme.media.onlyMobile`
    grid-column: 1;
`};
`

export const StyledIcon = styled(Icon)`
  margin-top: 2px;
`

export const StyledAcceptedCardImage = styled.img`
  height: ${rem(60)};
`



// WEBPACK FOOTER //
// ./src/views/PaymentDetails/OffSessionPayment/OffSessionCustomerPayment/OffSessionCustomerPayment.styles.ts